import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import * as styles from "./serviceCard.module.css";
const ServiceCard = ({ Text, title, imageSrc, contentDescription, }) => {
    return (_jsxs("article", { className: styles.cardContainer, children: [_jsx("img", { src: imageSrc, alt: contentDescription, height: 200, width: 400 }), _jsxs("div", { className: styles.cardTextContainer, children: [_jsx("h3", { className: typography.subHeader1, children: title }), _jsx(Text, {})] })] }));
};
export default ServiceCard;
